define('app/visualizations/PivotTable',['require','./VisualizationView','glu/$','glu/util','hbs!./PivotTable.hbs'],function(require) {
	'use strict';

	var VisualizationView = require('./VisualizationView'),
		$ = require('glu/$'),
		_ = require('glu/util');


	return VisualizationView.extend({

		serializeData: function() {
			return this;
		},

		template: require('hbs!./PivotTable.hbs'),

		onBeforeRender: function() {
			this.pivotData = this.model.consumableResults().pivot();
		},

		categories: function() {
			return _.map(this.pivotData.categories, this.pivotData.categoriesFormat);
		},

		rows: function() {
			var pivotData = this.pivotData;
			return _.map(pivotData.series, function(series) {
				return {
					header: pivotData.seriesFormat(series.title),
					data: _.map(series.collection.pluck('value'), pivotData.dataFormat),
					total: pivotData.dataFormat(series.total)
				};
			});
		},

		totalsRow: function() {
			var pivotData = this.pivotData;
			var sum = function(a, b) {
				return a + b;
			};

			var result = [];
			if (pivotData.categoryTotals.length > 0) {
				result = _.map(pivotData.categoryTotals.concat(_.reduce(pivotData.categoryTotals, sum)), pivotData.dataFormat);
			}

			return result;
		},

		getCSV: function() {
			var $rows = $('table tr');

			// Temporary delimiter characters unlikely to be typed by keyboard
			// This is to avoid accidentally splitting the actual contents
			var tmpColDelim = String.fromCharCode(11); // vertical tab character
			var tmpRowDelim = String.fromCharCode(0); // null character

			// actual delimiter characters for CSV format
			var colDelim = '","';
			var rowDelim = '"\r\n"';

			// Grab text from table into CSV formatted string
			var csv = '"' + $rows.map(function(i, row) {
					var $row = $(row),
						$cols = $row.find('td,th');

					return $cols.map(function(j, col) {
						var $col = $(col),
							text = $col.text();

						return text.replace(/"/g, '""'); // escape double quotes

					}).get().join(tmpColDelim);

				}).get().join(tmpRowDelim)
				.split(tmpRowDelim).join(rowDelim)
				.split(tmpColDelim).join(colDelim) + '"';

			// Data URI
			if (window.navigator.msSaveBlob) { //IE
				return new Blob([csv], {
					type: 'text/csv;charset=utf-8;'
				});
			} else {
				return 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);
			}
		}

	});

});

